import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { RequestsService } from '../../../provider/requests.service';
import { RequestHeaderModel } from '../../models/request-header.model';
import { MatDialog } from '@angular/material';
import { ReservationPerHourPopup } from '../popup/reservation-per-hour/reservation-per-hour.popup';
import { takeUntil } from 'rxjs/operators';
import { AppHotelService } from '../../../provider/app-hotel.service';
import { Subject } from 'rxjs';
import { ItemService } from 'src/app/provider/item.service';
import { MenuItemModel } from '../../models/menu-item.model';
import { MenuAsideService } from 'src/app/core/_base/layout';

export class ReservationModel {
  hour: string;
  baby: number;
  come_baby: number;
  child: number;
  come_child: number;
  person: number;
  come_person: number;
}

@Component({
  selector: 'c-reservation-list',
  templateUrl: './reservation-list.component.html',
  styleUrls: ['./reservation-list.component.scss']
})

export class ReservationListComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() ID: number;
  selectedValue = 'today';
  reservationData: ReservationModel[] = [];
  filteredData: RequestHeaderModel[] = [];
  destroyed$ = new Subject();
  itemDatas: RequestHeaderModel[] = [];

  constructor(
    public requestService: RequestsService,
    public dialog: MatDialog,
    private appHotel: AppHotelService,
    private itemServ: ItemService,
    private asideServ: MenuAsideService
  ) {
    asideServ.pathname$.next(window.location.pathname);
  }

  async ngOnChanges(changes: { [propKey: string]: any }) {

    const ITEMS = await this.itemServ.getItemsWithSectionId(157) as MenuItemModel[];
    this.ID = ITEMS[0].id;
    this.requestService.getRequest(this.ID, 'today');
    this.requestService.request_change$.subscribe((datas: RequestHeaderModel[]) => {
      if (datas) {
        const reservation = datas.filter(x => x.menu_item_id == this.ID);
        this.itemDatas = reservation.filter(x => x.status == 'Managed' || x.status == 'Updated' || x.status == 'ReserveList' || x.status == 'NotCome' || x.status == 'Come');
        this.filterData();
      }
    });
  }

  filterData() {
    let date = new Date();
    switch (this.selectedValue) {
      case 'yesterday':
        date = new Date(date.setDate(date.getDate() - 1));
        this.filteredData = this.itemDatas.filter(x => new Date(x.order_date).getDate() == date.getDate() && new Date(x.order_date).getMonth() == date.getMonth() && new Date(x.order_date).getFullYear() == date.getFullYear());
        break;
      case 'today':
        date = new Date();
        this.filteredData = this.itemDatas.filter(x => new Date(x.order_date).getDate() == date.getDate() && new Date(x.order_date).getMonth() == date.getMonth() && new Date(x.order_date).getFullYear() == date.getFullYear());
        break;
      case 'week':
        date = new Date(date.setDate(date.getDate() - 7));
        this.filteredData = this.itemDatas.filter(x => new Date(x.order_date).getTime() >= date.getTime());
        break;
    }
    console.log(this.filteredData);
    const hours: Set<string> = new Set(this.filteredData.map(x => new Date(x.order_date).getHours().toString() + ':' + new Date(x.order_date).getMinutes().toString()));
    const reservationModels: ReservationModel[] = [new ReservationModel()];
    hours.forEach(x => {
      const res: ReservationModel = new ReservationModel();
      res.hour = x;
      res.person = 0;
      res.come_person = 0;
      res.come_child = 0;
      res.come_baby = 0;
      res.child = 0;
      res.baby = 0;
      reservationModels.push(res);
    });
    this.filteredData.forEach(x => {
      if (x.requestlines) {
        x.requestlines.forEach(y => {
          if (y.name == 'Çocuk') {
            if (x.approval_status == 'Come') {
              reservationModels.find(z => z.hour == new Date(x.order_date).getHours().toString() + ':' + new Date(x.order_date).getMinutes().toString()).come_child += 1;
            }
            reservationModels.find(z => z.hour == new Date(x.order_date).getHours().toString() + ':' + new Date(x.order_date).getMinutes().toString()).child += 1;
          } else if (y.name == 'Bebek') {
            if (x.approval_status == 'Come') {
              reservationModels.find(z => z.hour == new Date(x.order_date).getHours().toString() + ':' + new Date(x.order_date).getMinutes().toString()).come_baby += 1;
            }
            reservationModels.find(z => z.hour == new Date(x.order_date).getHours().toString() + ':' + new Date(x.order_date).getMinutes().toString()).baby += 1;
          } else {
            if (x.approval_status == 'Come') {
              reservationModels.find(z => z.hour == new Date(x.order_date).getHours().toString() + ':' + new Date(x.order_date).getMinutes().toString()).come_person += y.quantity;
            }
            reservationModels.find(z => z.hour == new Date(x.order_date).getHours().toString() + ':' + new Date(x.order_date).getMinutes().toString()).person += y.quantity;
          }
        });
      }
    });
    this.reservationData = reservationModels;
  }

  ngOnInit() { }

  ngOnDestroy(): void {
    this.requestService.disconnectWs();
    this.destroyed$.next();
  }

  ngAfterViewInit(): void {
    this.appHotel.getHotelInfo(+JSON.parse(localStorage.getItem('token_form')).app_hotel_id).subscribe(
      (hotel) => {
        this.requestService.connectWs(hotel.group_hotels.split(',').join('-')).pipe(
          takeUntil(this.destroyed$)
        ).subscribe(request => {
          this.requestService.addRequest(request);
          setTimeout(() => {
          }, 200);
        }, (err) => {
          console.log('Web Socket Error : ' + err);
        }, () => {
          console.log('Web Socket is completed');
        });
      }
    );
  }

  changeStatus(data: RequestHeaderModel) {
    if (data.approval_status != 'Come') {
      data.approval_status = 'Come';
    } else {
      data.approval_status = 'NotCome';
    }
    this.requestService.putStatus(
      data.id,
      data.managed_by_user,
      data.approval_status,
      data.staff_note,
      data.place_code
    );
  }

  change() {
    // this.requestService.getRequest(this.ID, this.selectedValue);
    this.ngAfterViewInit();
  }

  onExporting(e) {
    console.log(e);
    // Handler of the "exporting" event
  }

  async gotoResHours() {
    this.reservationData.sort((a, b) => {
      if (a.hour < b.hour) {
        return -1;
      }
      if (a.hour > b.hour) {
        return 1;
      }
      return 0;
    });
    const dialogRef = this.dialog.open(ReservationPerHourPopup, { width: '700px', data: { data: this.reservationData } });
    dialogRef.afterClosed().subscribe((resp) => {
      console.log(resp);
    });

  }

  getQuantity(data: RequestHeaderModel) {
    let quantity = '';
    data.requestlines.forEach(x => {
      if (x.name != 'Bebek' && x.name != 'Çocuk') {
        quantity += x.quantity + 'Yetişkin ';
      } else {
        quantity += x.quantity + x.name + ' ';
      }
    });
    return quantity;
  }

  getExcelFileName() {
    let fileName = '';
    if (this.filteredData.length > 0) {
      fileName = this.filteredData[0].menu_item_name;
    } else {
      fileName = new Date().toDateString();
    }
    return fileName;
  }
}
